import { render, staticRenderFns } from "./IconBreach.vue?vue&type=template&id=711a49b5"
import script from "./IconBreach.vue?vue&type=script&lang=js"
export * from "./IconBreach.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports